import  portfolio from '../Images/portfolio-icon.svg'
import  contact from '../Images/contacrme.svg'
import  map from '../Images/map-icon.svg'
import  skills from '../Images/skills.svg'
import  personal from '../Images/personalinfo-icon.svg'
import portfolioSubmenu from '../Images/portfolio-submenu.webp'
import apoutMeSubmenu from '../Images/pesonalsubmenuImage.webp'
import skillsSubmenu from '../Images/Skillssubmenu.webp' 
import findMeSubmenu from '../Images/findmesubmenu.webp'
import contactSubmenu from '../Images/contactmesupmenu.webp'
export const iconsData = [
 {
  id : 1 ,
  title : 'portfolio',
  icon : portfolio,
  img:portfolioSubmenu
 },
 {
  id : 2 ,
  title : 'About Me',
  icon : personal,
  img:apoutMeSubmenu
 }
 ,
 {
  id : 3 ,
  title : 'contact me',
  icon :  contact,
  img:contactSubmenu
 }
 ,
 {
  id : 4 ,
  title : 'skills',
  icon : skills,
  img:skillsSubmenu
 }
 ,
 {
  id : 5 ,
  title : 'find me',
  icon : map,
  img:findMeSubmenu
 }
]